<template>
  <div class="table-expand">
    <div class="table-expand-material">
      <div class="content">
        <p>
          <Row>
            <Col span="22" class="content-title">规格</Col>
            <Col
              span="2"
              class="content-detail"
              style="text-align:right;"
              @click.native="collapseHandle"
            >
              详情
              <i v-if="collopse" class="iconfont icon-up2"></i>
              <i v-else class="iconfont icon-up21"></i>
            </Col>
          </Row>
        </p>
        <div
          :class="
            collopse
              ? ['fadeIn', 'animated', 'fast']
              : ['fadeInDown', 'animated', 'fast', 'hideHeight']
          "
        >
          <p
            v-if="row.product.status == 1"
            style="word-wrap: break-word;word-break: break-all;"
            class="title"
          >
            面料明细：含面料（库产品均包含面料）
          </p>
          <p
            v-else
            style="word-wrap: break-word;word-break: break-all;"
            class="title"
          >
            面料明细：{{
              row.product.specs[0].hasFabric ? "含面料" : "不含面料"
            }}
            <span v-if="fabric(row.product.specs[0])">{{
              fabric(row.product.specs[0])
            }}</span>
          </p>
          <p style="word-wrap: break-word;word-break: break-all;">
            尺寸: {{ row.product.specs[0].size }}
          </p>
          <p style="word-wrap: break-word;word-break: break-all;">
            材质: {{ row.product.specs[0].color }} &nbsp;&nbsp;{{
              row.product.specs[0].material
            }}
          </p>
        </div>
      </div>
    </div>
    <div class="modify-desc" v-if="row.changeDesc">
      <p class="modify-desc-title">变更描述</p>
      <p class="modify-desc-content">{{ row.changeDesc }}</p>
    </div>
  </div>
</template>

<script>
import Product from "@/mixins/Products";
export default {
  mixins: [Product],
  data() {
    return {
      collopse: true
    };
  },
  props: {
    row: Object
  },
  methods: {
    collapseHandle() {
      this.collopse = !this.collopse;
    }
  }
};
</script>

<style lang="scss" scoped>
.table-expand {
  background: #fff !important;
  padding: 0px !important;
}
.table-expand-material {
  padding: 10px 16px;
  background: #fafafa;
  .title {
    color: #313131;
  }
  .content {
    color: #707070;
    margin-top: 10px;
    span {
      color: #707070;
    }
    .hideHeight {
      overflow: hidden;
      height: 0px;
    }

    &-title {
      font-family: PingFang SC;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 16px;
      color: #313131;
      margin-bottom: 10px;
    }
    &-detail {
      font-family: PingFang SC;
      cursor: pointer;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 14px;
      text-align: justify;
      color: #999999;
      .iconfont {
        color: #999999;
        font-size: 14px;
      }
    }
  }
}

.modify-desc {
  background: #fef9ea;
  margin-top: 10px;
  &-title {
    font-family: PingFang SC;
    font-style: normal;
    background: #fef9ea;
    padding-top: 16px;
    padding-left: 16px;
  }
  &-content {
    font-family: PingFang SC;
    font-style: normal;
    font-weight: normal;
    color: #313131;
    padding-top: 12px;
    padding-left: 24px;
    padding-bottom: 16px;
    word-wrap: break-word;
    word-break: break-all;
  }
}
</style>
